import styled, { css } from 'styled-components'

// Utils
import { breakpoint } from '@sketch/global-styles'

export const Divider = styled.div`
  display: flex;
  margin: 0 8px;
  color: ${({ theme }) => theme.colors.state.disabled};
`

export interface ItemProps {
  $isActive: boolean
  $showAllInMobile?: boolean
  $isLink?: boolean
  $isCompleted: boolean
}

export const Item = styled.li<ItemProps>(
  ({ theme, $isActive, $showAllInMobile, $isLink, $isCompleted }) => css`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 0.8125rem;
    opacity: ${$isActive || $isCompleted ? '1' : '0.5'};
    pointer-events: ${$isActive ? 'none' : 'auto'};
    cursor: ${$isLink ? 'pointer' : 'default'};

    &:last-child {
      ${Divider} {
        display: none;
      }
    }

    &::before {
      content: counter(steps);
      counter-increment: steps;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 21px;
      height: 18px;
      margin-right: 8px;
      font-size: ${theme.fontSizes.B};
      margin-bottom: 2px; /* stylelint-disable-line scales/space */
      border-radius: ${theme.radii.rounded};

      /* Helps center the digit in the pill */
      line-height: 2; /* stylelint-disable-line scales/line-height */
      letter-spacing: 0;

      color: ${$isActive
        ? theme.colors.foreground.secondary.A
        : theme.colors.foreground.secondary.B};
      background-color: ${$isActive
        ? theme.colors.brand.green.default.E
        : theme.colors.background.tertiary.A};
    }

    ${breakpoint('base', 'sm')`
      ${
        !$showAllInMobile &&
        !$isActive &&
        css`
          width: 0;
          overflow: hidden;
        `
      }

      ${
        !$showAllInMobile &&
        css`
          ${Divider} {
            display: none;
          }
        `
      }
    `}
  `
)
